module.exports = __webpack_public_path__ + "img/full0-min.13f50550.png";